import styled from 'styled-components'
import { TextBox } from './TextBox'

const VerificationCodeTextBox = styled(TextBox).attrs({
  maxLength: 6,
})``

export { VerificationCodeTextBox }
